export const rentMaxPrices = {
    "en": [
        {
            value: '0',
            nom: 'Max Price'
        },
        {
            value: '3000',
            nom: '3,000'
        },
        {
            value: '5000',
            nom: '5,000'
        },
        {
            value: '7500',
            nom: '7,500'
        },
        {
            value: '10000',
            nom: '10,000'
        },
        {
            value: '12500',
            nom: '12,500'
        },
        {
            value: '15000',
            nom: '15,000'
        },
        {
            value: '17500',
            nom: '17,500'
        },
        {
            value: '20000',
            nom: '20,000'
        },
        {
            value: '22500',
            nom: '22,500'
        },
        {
            value: '25000',
            nom: '25,000'
        },
        {
            value: '30000',
            nom: '30,000'
        },
        {
            value: '35000',
            nom: '35,000'
        },
        {
            value: '40000',
            nom: '40,000'
        },
        {
            value: '50000',
            nom: '50,000'
        },
        {
            value: '60000',
            nom: '60,000'
        },
        {
            value: '70000',
            nom: '70,000'
        },
        {
            value: '80000',
            nom: '80,000'
        },
        {
            value: '90000',
            nom: '90,000'
        },
        {
            value: '100000',
            nom: '100,000'
        },
        {
            value: '125000',
            nom: '125,000'
        },
        {
            value: '150000',
            nom: '150,000'
        },
        {
            value: '175000',
            nom: '175,000'
        },
        {
            value: '200000',
            nom: '200,000'
        },
        {
            value: '250000',
            nom: '250,000'
        },
        {
            value: '300000',
            nom: '300,000'
        },
        {
            value: '400000',
            nom: '400,000'
        },
        {
            value: '500000',
            nom: '500,000'
        },
        {
            value: '750000',
            nom: '750,000'
        },
        {
            value: '1000000',
            nom: '1,000,000'
        }
    ],
    "th": [
        {
            value: '0',
            nom: 'ราคาสูงสุด'
        },
        {
            value: '3000',
            nom: '3,000'
        },
        {
            value: '5000',
            nom: '5,000'
        },
        {
            value: '7500',
            nom: '7,500'
        },
        {
            value: '10000',
            nom: '10,000'
        },
        {
            value: '12500',
            nom: '12,500'
        },
        {
            value: '15000',
            nom: '15,000'
        },
        {
            value: '17500',
            nom: '17,500'
        },
        {
            value: '20000',
            nom: '20,000'
        },
        {
            value: '22500',
            nom: '22,500'
        },
        {
            value: '25000',
            nom: '25,000'
        },
        {
            value: '30000',
            nom: '30,000'
        },
        {
            value: '35000',
            nom: '35,000'
        },
        {
            value: '40000',
            nom: '40,000'
        },
        {
            value: '50000',
            nom: '50,000'
        },
        {
            value: '60000',
            nom: '60,000'
        },
        {
            value: '70000',
            nom: '70,000'
        },
        {
            value: '80000',
            nom: '80,000'
        },
        {
            value: '90000',
            nom: '90,000'
        },
        {
            value: '100000',
            nom: '100,000'
        },
        {
            value: '125000',
            nom: '125,000'
        },
        {
            value: '150000',
            nom: '150,000'
        },
        {
            value: '175000',
            nom: '175,000'
        },
        {
            value: '200000',
            nom: '200,000'
        },
        {
            value: '250000',
            nom: '250,000'
        },
        {
            value: '300000',
            nom: '300,000'
        },
        {
            value: '400000',
            nom: '400,000'
        },
        {
            value: '500000',
            nom: '500,000'
        },
        {
            value: '750000',
            nom: '750,000'
        },
        {
            value: '1000000',
            nom: '1,000,000'
        }
    ],
    "cn": [
        {
            value: '0',
            nom: '最高价格'
        },
        {
            value: '3000',
            nom: '3,000'
        },
        {
            value: '5000',
            nom: '5,000'
        },
        {
            value: '7500',
            nom: '7,500'
        },
        {
            value: '10000',
            nom: '10,000'
        },
        {
            value: '12500',
            nom: '12,500'
        },
        {
            value: '15000',
            nom: '15,000'
        },
        {
            value: '17500',
            nom: '17,500'
        },
        {
            value: '20000',
            nom: '20,000'
        },
        {
            value: '22500',
            nom: '22,500'
        },
        {
            value: '25000',
            nom: '25,000'
        },
        {
            value: '30000',
            nom: '30,000'
        },
        {
            value: '35000',
            nom: '35,000'
        },
        {
            value: '40000',
            nom: '40,000'
        },
        {
            value: '50000',
            nom: '50,000'
        },
        {
            value: '60000',
            nom: '60,000'
        },
        {
            value: '70000',
            nom: '70,000'
        },
        {
            value: '80000',
            nom: '80,000'
        },
        {
            value: '90000',
            nom: '90,000'
        },
        {
            value: '100000',
            nom: '100,000'
        },
        {
            value: '125000',
            nom: '125,000'
        },
        {
            value: '150000',
            nom: '150,000'
        },
        {
            value: '175000',
            nom: '175,000'
        },
        {
            value: '200000',
            nom: '200,000'
        },
        {
            value: '250000',
            nom: '250,000'
        },
        {
            value: '300000',
            nom: '300,000'
        },
        {
            value: '400000',
            nom: '400,000'
        },
        {
            value: '500000',
            nom: '500,000'
        },
        {
            value: '750000',
            nom: '750,000'
        },
        {
            value: '1000000',
            nom: '1,000,000'
        }
    ],
    "ru": [
        {
            value: '0',
            nom: 'Макс. цена'
        },
        {
            value: '3000',
            nom: '3,000'
        },
        {
            value: '5000',
            nom: '5,000'
        },
        {
            value: '7500',
            nom: '7,500'
        },
        {
            value: '10000',
            nom: '10,000'
        },
        {
            value: '12500',
            nom: '12,500'
        },
        {
            value: '15000',
            nom: '15,000'
        },
        {
            value: '17500',
            nom: '17,500'
        },
        {
            value: '20000',
            nom: '20,000'
        },
        {
            value: '22500',
            nom: '22,500'
        },
        {
            value: '25000',
            nom: '25,000'
        },
        {
            value: '30000',
            nom: '30,000'
        },
        {
            value: '35000',
            nom: '35,000'
        },
        {
            value: '40000',
            nom: '40,000'
        },
        {
            value: '50000',
            nom: '50,000'
        },
        {
            value: '60000',
            nom: '60,000'
        },
        {
            value: '70000',
            nom: '70,000'
        },
        {
            value: '80000',
            nom: '80,000'
        },
        {
            value: '90000',
            nom: '90,000'
        },
        {
            value: '100000',
            nom: '100,000'
        },
        {
            value: '125000',
            nom: '125,000'
        },
        {
            value: '150000',
            nom: '150,000'
        },
        {
            value: '175000',
            nom: '175,000'
        },
        {
            value: '200000',
            nom: '200,000'
        },
        {
            value: '250000',
            nom: '250,000'
        },
        {
            value: '300000',
            nom: '300,000'
        },
        {
            value: '400000',
            nom: '400,000'
        },
        {
            value: '500000',
            nom: '500,000'
        },
        {
            value: '750000',
            nom: '750,000'
        },
        {
            value: '1000000',
            nom: '1,000,000'
        }
    ],
    "de": [
        {
            value: '0',
            nom: 'Maximaler Preis'
        },
        {
            value: '3000',
            nom: '3,000'
        },
        {
            value: '5000',
            nom: '5,000'
        },
        {
            value: '7500',
            nom: '7,500'
        },
        {
            value: '10000',
            nom: '10,000'
        },
        {
            value: '12500',
            nom: '12,500'
        },
        {
            value: '15000',
            nom: '15,000'
        },
        {
            value: '17500',
            nom: '17,500'
        },
        {
            value: '20000',
            nom: '20,000'
        },
        {
            value: '22500',
            nom: '22,500'
        },
        {
            value: '25000',
            nom: '25,000'
        },
        {
            value: '30000',
            nom: '30,000'
        },
        {
            value: '35000',
            nom: '35,000'
        },
        {
            value: '40000',
            nom: '40,000'
        },
        {
            value: '50000',
            nom: '50,000'
        },
        {
            value: '60000',
            nom: '60,000'
        },
        {
            value: '70000',
            nom: '70,000'
        },
        {
            value: '80000',
            nom: '80,000'
        },
        {
            value: '90000',
            nom: '90,000'
        },
        {
            value: '100000',
            nom: '100,000'
        },
        {
            value: '125000',
            nom: '125,000'
        },
        {
            value: '150000',
            nom: '150,000'
        },
        {
            value: '175000',
            nom: '175,000'
        },
        {
            value: '200000',
            nom: '200,000'
        },
        {
            value: '250000',
            nom: '250,000'
        },
        {
            value: '300000',
            nom: '300,000'
        },
        {
            value: '400000',
            nom: '400,000'
        },
        {
            value: '500000',
            nom: '500,000'
        },
        {
            value: '750000',
            nom: '750,000'
        },
        {
            value: '1000000',
            nom: '1,000,000'
        }
    ],
    "fr": [
        {
            value: '0',
            nom: 'Prix maximum'
        },
        {
            value: '3000',
            nom: '3,000'
        },
        {
            value: '5000',
            nom: '5,000'
        },
        {
            value: '7500',
            nom: '7,500'
        },
        {
            value: '10000',
            nom: '10,000'
        },
        {
            value: '12500',
            nom: '12,500'
        },
        {
            value: '15000',
            nom: '15,000'
        },
        {
            value: '17500',
            nom: '17,500'
        },
        {
            value: '20000',
            nom: '20,000'
        },
        {
            value: '22500',
            nom: '22,500'
        },
        {
            value: '25000',
            nom: '25,000'
        },
        {
            value: '30000',
            nom: '30,000'
        },
        {
            value: '35000',
            nom: '35,000'
        },
        {
            value: '40000',
            nom: '40,000'
        },
        {
            value: '50000',
            nom: '50,000'
        },
        {
            value: '60000',
            nom: '60,000'
        },
        {
            value: '70000',
            nom: '70,000'
        },
        {
            value: '80000',
            nom: '80,000'
        },
        {
            value: '90000',
            nom: '90,000'
        },
        {
            value: '100000',
            nom: '100,000'
        },
        {
            value: '125000',
            nom: '125,000'
        },
        {
            value: '150000',
            nom: '150,000'
        },
        {
            value: '175000',
            nom: '175,000'
        },
        {
            value: '200000',
            nom: '200,000'
        },
        {
            value: '250000',
            nom: '250,000'
        },
        {
            value: '300000',
            nom: '300,000'
        },
        {
            value: '400000',
            nom: '400,000'
        },
        {
            value: '500000',
            nom: '500,000'
        },
        {
            value: '750000',
            nom: '750,000'
        },
        {
            value: '1000000',
            nom: '1,000,000'
        }
    ]
}